import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { adsService } from '../services/ads.service';
import { getApiErrorMessage } from '@/lib/utils/api-errors';

export function useDeleteCampaign() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (refId: string) => adsService.deleteCampaign(refId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      toast.success('Campagne supprimée avec succès');
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error));
    },
  });
}
